<template>
  <div>
    <page-navigate></page-navigate>
   
    <div class="activity-container">
      <!-- PC端视图 -->
      <div v-if="!isMobile" class="pc-version">
        <div class="image-wrapper">
          <div v-for="i in 10" :key="`pc-${i}`" class="image-section">
              <img :src="getImageUrl(`pc-${i}`)" alt="" class="section-image" />
              <template v-if="i === 2">
                <a href="https://client.ebccrm.com/signup-b?bid=5s71xp&utm_source=cnwebsite&utm_medium=landingpage&utm_campaign=head&utm_content=cn2510" target="_blank" rel="noopener noreferrer" class="hotspot"
                   style="top: 58%;left: 19%;width: 14.02%;height: 11.5%;" title=""></a>
              </template>
              <template v-if="i === 6">
                <a href="https://forms.office.com/r/mAKLKVLThg" target="_blank" rel="noopener noreferrer" class="hotspot"
                   style="top:1%;left: 50%;width: 10.63%;transform: translateX(-50%);height: 11.5%;" title=""></a>
              </template>
              <template v-if="i === 9">
                <a href="https://forms.office.com/r/s8HTUMgvzR" target="_blank" rel="noopener noreferrer" class="hotspot"
                   style="bottom: 6%;left: 50%;width: 14.63%;transform: translateX(-50%);height: 11.5%;" title=""></a>
              </template>
            </div>
        </div>
      </div>

      <!-- 移动端视图 -->
      <div v-if="isMobile" class="mobile-version">
        <div class="image-wrapper">
         <div v-for="i in 10" :key="`m-${i}`" class="image-section">
              <img :src="getImageUrl(`m-${i}`)" alt="" class="section-image" />
              <template v-if="i === 3">
                <a href="https://client.ebccrm.com/signup-b?bid=5s71xp&utm_source=cnwebsite&utm_medium=landingpage&utm_campaign=head&utm_content=cn2510" target="_blank" rel="noopener noreferrer" class="hotspot"
                   style="top: 33%;left: 50%;transform: translateX(-50%);width: 92%;height: 15.67%;" title=""></a>
              </template>
            </div>
        </div>
      </div>

    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
export default {
  name: 'MidAutumnFestival',
  data() {
    return {
      isMobile: false,
      imageBasePath: '/img/japan1122/', 
    };
  },
  computed: {
    isSimplified() { return this.$i18n.locale.toLowerCase() === 'zh'; },
  },
  created() {
    if (!this.isSimplified) {
      this.$router.replace('/'); 
    }
  },
  methods: {
    handleResize() { this.isMobile = window.innerWidth < 995; },
    getImageUrl(name) { return `${this.imageBasePath}${name}.jpeg?v=1.2`; },
    toggleDebugMode(e) { if (e.key === 'F12') { e.preventDefault(); document.body.classList.toggle('debug-hotspots'); } }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('keydown', this.toggleDebugMode);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('keydown', this.toggleDebugMode);
  }
};
</script>

<style scoped>

.activity-container {
  width: 100%;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%; 
}


.image-section {
  position: relative;
  line-height: 0; 
  font-size: 0;
}

.section-image {
  width: 100%; 
  height: auto;
  display: block;
  user-drag: none;
  user-select: none;
  pointer-events: none;
}
.image-section:last-child {
  margin-bottom: -1px;
}
.hotspot {
  position: absolute;
  z-index: 2;
  cursor: pointer;
  background: transparent;
  transition: background 0.2s ease;
  border-radius: 8px;
}
.debug .hotspot{
  border:3px solid red;
}
</style>